// lib/tickets/checklistenZeile.ts
// Ein Checklisten-Kästchen (☐/☑ am Zeilenanfang) in einem Text umschalten — gemeinsam
// für Ticket-Beschreibung und Notizen im Verlauf (#526).

/** Neuer Text mit umgeschalteter Zeile, oder null, wenn die Zeile kein Kästchen ist. */
export function schalteChecklistenZeile(text: string, zeile: number, erledigt: boolean): string | null {
  const zeilen = text.split('\n');
  const z = zeilen[zeile];
  if (z === undefined || !(z.startsWith('☐ ') || z.startsWith('☑ '))) return null;
  zeilen[zeile] = (erledigt ? '☑ ' : '☐ ') + z.slice(2);
  return zeilen.join('\n');
}
